import { render, staticRenderFns } from "./allinMerchantAccountList.vue?vue&type=template&id=37e5a244&scoped=true"
import script from "./allinMerchantAccountList.vue?vue&type=script&lang=ts"
export * from "./allinMerchantAccountList.vue?vue&type=script&lang=ts"
import style0 from "./allinMerchantAccountList.vue?vue&type=style&index=0&id=37e5a244&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e5a244",
  null
  
)

export default component.exports